module.exports = __webpack_public_path__ + "static/media/RecomendaBonita.2d9cf369.jpg";